import { atom } from "jotai";

type WebchatPreviewMode = "home" | "chat" | "banner" | "banner";
export type WebchatPreviewChatModeOption = "default" | "bottom-menu";
export type WebchatPreviewBannerMode = "desktop" | "mobile";

export const webchatPreviewModeAtom = atom<{
    mode: WebchatPreviewMode;
    chatModeOption?: WebchatPreviewChatModeOption;
    bannerMode?: WebchatPreviewBannerMode;
}>({
    mode: "chat",
    chatModeOption: "default",
    bannerMode: "desktop"
});
